(function() {
    'use strict';

    /*
    * A module for handling admin-related routes (e.g. /admin and /audit).
    *
    */

    // Register all routes handled by this module
    angular
    .module('GorillaBoy.Admin')
    .constant('UserStatus', {
        USER_STATUS_ACTIVE: 'ACTIVE',
        USER_STATUS_INACTIVE: 'INACTIVE',
        USER_STATUS_PENDING: 'PENDING'
    })
    .constant('StorageType', {
        STORAGE_UNLIMITED_TYPE: 'UNLIMITED',
        STORAGE_QUOTA_TYPE: 'QUOTA'
    })
    .config(['$routeProvider', function ($routeProvider) {
        var TEMPLATE_LAYOUT = './assets/partials/app/layout.html';

        $routeProvider
        .when('/admin', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'AdministrationController',
            auth: true,
            resolve: {
                userInfo: resolveUserInfo(),
                featureMap: ['FeatureManagerService', function (featureManagerService) {
                    return featureManagerService.getEnabledFeatureMap();
                }]
            }
        });

        function resolveUserInfo () {
            return ['$q', 'AuthService', '$location', function ($q, authService, $location) {
                var deferred = $q.defer();
                authService.getUserInfo()
                .then(function (user) {
                    if (user && user.Administrator) {
                        deferred.resolve(user);
                    } else {
                        $location.url('/mydocs').replace();
                        deferred.resolve({error: 'Only administrators can view this page.'});
                    }
                });

                return deferred.promise;
            }];
        }

    }]);
}());
